import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import { type SidebarMenuButtonVariants, sidebarMenuButtonVariants } from '.'

export interface SidebarMenuButtonProps extends PrimitiveProps {
  variant?: SidebarMenuButtonVariants['variant']
  size?: SidebarMenuButtonVariants['size']
  isActive?: boolean
  class?: HTMLAttributes['class']
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenuButtonChild',
  props: {
    variant: { default: 'default' },
    size: { default: 'default' },
    isActive: { type: Boolean },
    class: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: 'button' }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Primitive), _mergeProps({
    "data-slot": "sidebar-menu-button",
    "data-sidebar": "menu-button",
    "data-size": _ctx.size,
    "data-active": _ctx.isActive,
    class: _unref(cn)(_unref(sidebarMenuButtonVariants)({ variant: _ctx.variant, size: _ctx.size }), props.class),
    as: _ctx.as,
    "as-child": _ctx.asChild
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["data-size", "data-active", "class", "as", "as-child"]))
}
}

})